import { render, staticRenderFns } from "./Chapter_2.vue?vue&type=template&id=6ca384d5&scoped=true&lang=pug&"
import script from "./Chapter_2.vue?vue&type=script&lang=js&"
export * from "./Chapter_2.vue?vue&type=script&lang=js&"
import style0 from "./Chapter_2.vue?vue&type=style&index=0&id=6ca384d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca384d5",
  null
  
)

export default component.exports